export const currencyToFormat = (value: number | string, currency = "USD") =>
  Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: 2,
  });
